module.exports = __webpack_public_path__ + "static/media/logo-lunch-team.2a34be80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-lunch-team.svg
// module id = 328
// module chunks = 7